// extracted by mini-css-extract-plugin
module.exports = {"block":"_1026","hd":"_8598","title":"_3208","arrow":"_3870","empty":"_13144","bd":"_1135","ft":"_2814"};